export const LogoMark = ({ className = "h-10 w-auto", variant = "light" }) => (
  <img src={`/emblem-${variant === "dark" ? "black" : "light"}.png`} alt="Sterling Joinery emblem" className={`${className} object-contain`} />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    {!compact && (
      <span className="leading-none">
        <span className="block font-display text-xl tracking-wide text-[#F5F3EF]">Sterling</span>
        <span className="block font-mono-j text-[10px] tracking-[0.35em] uppercase text-[#C5A059]">Joinery · Atlas</span>
      </span>
    )}
  </span>
);
